const $ = require('jquery');
// h.c: required by a badly behaved bootstrap
window.jQuery = $;
global.$ = global.jQuery = $;

require('bootstrap');
require('bootstrap-select');
require('configurable-date-input-polyfill');
const select2 = require('select2');
require('./select2entity');
require('./form-locker');

require('datatables.net')(window, $);
require('datatables.net-bs')(window, $);

select2($);

$(document).on('click', 'a.long-task', function (ev) {
  var $this = $(this);
  if ($this.hasClass('active')) {
    return false;
  }

  $this.addClass('active');
  ev.target.innerHTML += "<div class=\"spinner\">\n" +
    "  <div class=\"double-bounce1\"></div>\n" +
    "  <div class=\"double-bounce2\"></div>\n" +
    "</div>";
});

// data-* replacements for the inline onclick= handlers that the CSP forbids
// (docs/architectural_decisions/csp_nonce_unsafe_inline_removal.md). Bound once here;
// a template must not bind them again or every click opens one dialog per binder (PT-3630).
$(document).on('click', '[data-confirm]', function (ev) {
  if (!confirm(this.dataset.confirm)) {
    ev.preventDefault();
  }
});

$(document).on('click', '[data-alert]', function (ev) {
  ev.preventDefault();
  alert(this.dataset.alert);
});

$(document).on('click', '[data-action="expand-select2"]', function () {
  $(this).parent().parent().parent().find('.select2entity').select2entity({ width: '100%' });
});

$(document).on('click', '[data-action="remove-panel"]', function (ev) {
  ev.preventDefault();
  if (confirm('Really remove this item?')) {
    $(this).closest('.panel').remove();
  }
});

window.bindToContactType = function () {
  const contactType = $('.contact-type')

  const modifyForm = function (target) {
    let optionalAddress = target.val() === 'additional-billing'

    target.not('#employee_contact_type')
      .closest('div.panel-body')
      .find('input.contact-address')
      .attr('required', !optionalAddress)
  }

  contactType.each(function (index) {
    modifyForm($(this))
  })

  contactType.change(function (el0) {
    let target = $(el0.target)
    modifyForm(target)
  })
}

$(function () {
  $('[data-toggle="tooltip"]').tooltip();

  $('.form-control[data-help]').each(function (_, el) {
    const $el = $(el);
    const helpBlock = $('<p class="help-block"></p>');
    helpBlock.append($el.data('help'));
    $el.parent('.form-group').append(helpBlock);
  });

  $(".datatable").each(function (_, el) {
    const $el = $(el);

    let columnDefs = $el.data('columnConfig');
    if (columnDefs) {
      columnDefs = window[columnDefs]();
    }

    const table = $el.DataTable({
      columnDefs: columnDefs,
      serverSide: true,
      ajax: $el.data('remoteUrl'),
      stateSave: true,
      orderCellsTop: true,
      processing: true,
      searchDelay: 800,
    });

    const rowClickFn = window[$el.data('rowClick')];
    if (rowClickFn) {
      $el.on('click auxclick', 'tbody tr', function (e) {
        if (e.button === 2 || e.target.closest('a, button, input, select, textarea, label')) {
          return;
        }
        e.preventDefault();
        let openInNewTab = e.ctrlKey || e.which === 2 || e.metaKey
        rowClickFn(table.row(this).data(), openInNewTab);
      });
    }

    table.on('init', function () {
      // DataTables remembers filtering state. On initialisation make sure the existing filter inputs are in sync.
      $el.find('.filter').each(function (_, el) {
        const $th = $(el).closest('th');
        const colIdx = $th.parent().children().index($th);

        if (table.column(colIdx).search() != "") {
          $(el).val(table.column(colIdx).search()).trigger("change");
        }
      });

      // Wire up handlers to update DataTables filter state when filter inputs change.
      // wiring inside the init event to avoid performing an ajax call for every applied filter because of triggering the change event.
      $el.find('.filter').on('change', function (ev) {
        const $this = $(this);
        const $th = $this.closest('th');
        const colIdx = $th.parent().children().index($th);
        table.column(colIdx).search($this.val() || '').draw();
      });
    });
  });

  $('.select2[data-autostart="true"]').select2();

  const enableRemindersCheckbox = $('#organisation_portalConfigStore_enableEmailReminders')
  const remindersEmailsTextField = $('#organisation_portalConfigStore_reminderAdminEmails')

  remindersEmailsTextField.prop('disabled', !enableRemindersCheckbox.is(':checked'))
  enableRemindersCheckbox.change(function () {
    remindersEmailsTextField.prop('disabled', !enableRemindersCheckbox.is(':checked'))
  })

  const getCurrencySymbol = function (value) {
    switch (value) {
      case 'USD':
        return '$ '
      case 'GBP':
        return '£ '
      case 'EUR':
      default:
        return '€ '
    }
  }

  const formCurrencyDropdown = $('#sourcing_currency, #sale_currency, #repair_currency')
  const formNettoBuyingPrice = $('#sourcing_nettoBuyingPrice, #sale_sellingPriceNetto, #repair_cost')

  formCurrencyDropdown.change(
    function () {
      formNettoBuyingPrice.prev().text(getCurrencySymbol(formCurrencyDropdown.val()))
    }
  )

  bindToContactType()
});

// show modal with link to instructions when the user tries to change PaysTo value on Org
let clicked = false
document.addEventListener("DOMContentLoaded", function () {
  let paysToSelect = document.getElementById("organisation_paysTo");
  if (paysToSelect !== null) {
    paysToSelect.onclick = function () {
      if (!clicked) {
        $('.modal').modal('show');
        clicked = true
        return false;
      }
    }
  }
});

require("./global-search/main");
